import React from "react";
import {Modal, ScrollView, View} from "react-native";
import MainStyle from "../../MainStyle";
import {useNavigation} from "@react-navigation/native";
import Div from "../lib/Div";
import {isFullSwing} from "../constants";
import {colors} from "../assets/styles/colors";
import P from "../lib/P";
import Btn from "../components/Btn";

type Props = { isOpen: boolean, onClose: () => void };

const InsufficientFundsPopup = (props: Props) => {
  const {isOpen} = props;
  const navigation: any = useNavigation();

  const playSolo = () => {
    navigation.reset({index: 0, routes: [{name: 'challenges'}]});
  };

  const onDeposit = () => {
    navigation.reset({index: 0, routes: [{name: 'account', params: {step: 1}}]});
  };

  return (
    <Modal animationType="fade" transparent visible={isOpen} statusBarTranslucent={false} hardwareAccelerated={false}
           onRequestClose={props.onClose}>
      <View style={[MainStyle.fix_gradient_and_modal_error_in_landscape, MainStyle.flex1, MainStyle.bg_filter_modal]}>
        <ScrollView contentContainerStyle={MainStyle.flex1}>
          <Div minH="100%" alignItems="center" justifyContent="center">
            <Div bg={isFullSwing ? '#131314' : colors.settings_bg} w={365} rounded={20}
                 borderColor={colors.settings_border} borderWidth={1} pt={30} minH={510} pb={68}>
              <P fw="500" fs={23} ml={37} w={255}>
                {'You don’t have enough money in your wallet right now.\nFriend Challenges require Withdrawable Funds to enter.'}
              </P>

              <Div flex={1}/>

              <Div mx={40}>
                <Btn rounded={isFullSwing ? 4 : 70} bg={isFullSwing ? '#3369FF' : colors.newGreenText} mb={20} h={63}
                     justifyContent="center" onPress={onDeposit}>
                  <P color={isFullSwing ? 'white' : colors.mainBackground} ta="center" fw="600" fs={18}>
                    DEPOSIT TO PLAY
                  </P>
                </Btn>

                <Btn rounded={isFullSwing ? 4 : 70} bg={isFullSwing ? '#252526' : colors.mainBackground} borderWidth={1}
                     borderColor={isFullSwing ? '#4C4C4C' : colors.whiteText} h={63} justifyContent="center" mb={20}
                     onPress={playSolo}>
                  <P ta="center" fw="600" fs={18} mx={23}>Play Solo</P>
                </Btn>

                <Btn rounded={isFullSwing ? 4 : 70} bg={isFullSwing ? '#252526' : colors.mainBackground} borderWidth={1}
                     borderColor={isFullSwing ? '#4C4C4C' : colors.whiteText} h={63} justifyContent="center"
                     onPress={props.onClose}>
                  <P ta="center" fw="600" fs={18}>Cancel</P>
                </Btn>
              </Div>
            </Div>
          </Div>
        </ScrollView>
      </View>
    </Modal>
  );
};

export default React.memo(InsufficientFundsPopup);
